import React, { useEffect, useState } from 'react';
import LeadsDataGrid from '../../components/Lead/Page/LeadsDataGrid';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { grey } from '@mui/material/colors';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import useApiManager from '../../utils/Api/apiManager';
import { useParams } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import FilterComponent from '../../components/Lead/Page/FilterComponent';
import ActionsButton from '../../components/Lead/Page/ActionsButton';

const LeadsPage = () => {
  const [filters, setFilters] = useState(() => {
    const savedFilters = localStorage.getItem('leadsFilters');
    return savedFilters ? JSON.parse(savedFilters) : [];
  });

  useEffect(() => {
    if (filters.length >= 0) {
      localStorage.setItem('leadsFilters', JSON.stringify(filters));
    }
  }, [filters]);

  const [triggerFetch, setTriggerFetch] = useState(false); // when deleting a row, refetching the data in datagrid
  const [selectedRows, setSelectedRows] = useState([]); // State to store selected row IDs

  // Function to handle row selection
  const handleSelectionChange = (newSelection) => {
    setSelectedRows(newSelection); // Store selected row IDs
  };

  useEffect(() => {
    document.title = "Leads - iLead CRM";
  }, []);

  return (<>
    <Box sx={{ p: 2, height: '100%', display: 'flex' }}>
      <Grid container spacing={2} sx={{ height: '100%' }}>
        <Grid item xs={2.7} sx={{ height: '100%' }}>
          <Paper elevation={3} sx={{ height: 'calc(100vh - 105px)', p: 1, display: 'flex', flexDirection: 'column' }}>
            {/* Ensure FilterComponent also takes full height */}
            <FilterComponent filters={filters} setFilters={setFilters} sx={{ flex: 1, overflow: 'auto' }} />
          </Paper>
        </Grid>

        <Grid item xs={9.3} sx={{ height: '100%' }}>
          <Paper
            elevation={3}
            sx={{
              height: 'calc(100vh - 105px)',
              display: 'flex',
              flexDirection: 'column',
              p: 1,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '8px',
              }}
            >
              <h3>Leads</h3>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Link to="/leads/create">
                  <Button variant="contained" type="submit">Create Lead</Button>
                </Link>
                <ActionsButton itemIds={selectedRows} setSelectedRows={setSelectedRows} setTriggerFetch={setTriggerFetch} />
              </Box>
            </Box>

            <Box sx={{ flex: 1, overflow: 'hidden' }}>
              {/* Ensure CampaignsDataGrid takes up full height */}
              <LeadsDataGrid filters={filters} selectedRows={selectedRows} onSelectionModelChange={handleSelectionChange} triggerFetch={triggerFetch} setTriggerFetch={setTriggerFetch} />
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  </>
  )
};

export default LeadsPage;
